import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

import Stats from 'ui/pages/Stats';

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/stats">
      <Stats/>
    </PageNextJs>
  );
};

export default Page;

export const getServerSideProps = async(ctx: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale || 'en', [ 'common' ])),
    },
  };
};
